export default __webpack_public_path__ + "static/media/logo-bk.9d101f26.svg";